import { Prisma } from "@prisma/client";

export const bankDetailsTypeValues =
  Prisma.validator<Prisma.BankDetailsDefaultArgs>()({
    select: {
      id: true,
      accountName: true,
      iban: true,
      bic: true,
    },
  });

export type BankDetailsType = Prisma.BankDetailsGetPayload<
  typeof bankDetailsTypeValues
>;

export type ApiBankDetails = BankDetailsType & {
  currentlyUsedByEvents: string[];
};
